// @ts-nocheck
import React, { useEffect, useState } from "react";
import "../../styles/contacts.css";

import { Helmet } from "react-helmet";
import ContactsCard from "./ContactsCard";
import ContactsInfo from "./ContactsInfo";
import { useStores } from "hooks/useStores";
import Seo from 'components/Seo';

const ContactsPage = () => {
  const [mainItems, setMainItems] = useState({});
  const [managers, setManagers] = useState([]);
  const [contacts, setContacts] = useState({});
  const { api } = useStores();


  useEffect(() => {
    api.content.getPageApi("contacts")
      .then((response) => {
      if (response) {
        setContacts(response.init_state.contacts);
        setMainItems(response.init_state.object);
        setManagers(response.init_state.managers);
      }
    })
  }, []);

  const organizationJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Пак Пакыч",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": contacts.address,
      "postalCode": contacts.city_index,
      "addressLocality": "Ивантеевка",
      "addressCountry": "RU"
    },
    "telephone": contacts.phone,
    "email": contacts.email,
    "openingHours": contacts.working_days_and_hours,
    "url": window.location.origin,
    "contactPoint": [{
      "@type": "ContactPoint",
      "telephone": contacts.phone,
      "email": contacts.email,
      "contactType": "customer support"
    }]
  };

  return (
    <>
      <Seo seo={mainItems} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <main id="contactsPage">
        <section className="contacts">
          <div className="contacts-wrap">
            <h1 className="contacts-title">Контакты</h1>
            <div className="contacts-container">
              <div className="contacts-info">
                <ContactsInfo contacts={contacts} />
                <div className="contacts-cards-container">
                  {managers?.map((manager) => (
                    <ContactsCard key={manager.id} manager={manager} />
                  ))}
                </div>
              </div>
              <div className="pickup-map-contacts">
                <iframe
                  className="map-contacts"
                  title="map"
                  frameBorder={0}
                  src={contacts.driving_scheme_url}
                ></iframe>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default ContactsPage;
